import React from 'react';
import DiarizedTranscript from './DiarizedTranscript';
import SpeechRatioBar from './SpeechRatioBar';
import TopicTags from './TopicTags';
import './Diarization.css';

/**
 * 話者分離の結果の表示 (SCR-D-001 §3.2・§4.2・§7.3)。
 *
 * 1280px 以上は 2 カラム (左: 発話の並び、右: 発話比率バーとトピックタグ)、それ未満は縦に積む。
 * 受け取る `result` は画面の内部の形で、API の応答からの変換は呼出側で 1 か所にまとめる
 * (API の形が変わっても、描画側を直さないため。#1247 段階分けの案)。
 *
 * @param {{result: {
 *   utterances: Array<{index: number, role: string, text: string}>,
 *   ratio: {agent: number, candidate: number, unknown: number},
 *   topics: string[],
 *   roleConfidence: string,
 * }}} props
 */
function DiarizationResult({ result }) {
    return (
        <div className="diar-result" data-testid="diarization-result">
            <div className="diar-result-main">
                <DiarizedTranscript utterances={result.utterances} roleConfidence={result.roleConfidence} />
            </div>
            <div className="diar-result-side">
                <SpeechRatioBar ratio={result.ratio} />
                <TopicTags topics={result.topics} />
            </div>
        </div>
    );
}

export default DiarizationResult;
